<div class="context-menu" [ngClass]="{'submenu-left': !submenuRightSide}" [style.left.px]="adjustedPosition.x || 0" [style.top.px]="adjustedPosition.y || 0" (contextmenu)="onContextMenu($event)" #menu>
    <div 
      class="menu-item"
      *ngFor="let item of items"
      [ngClass]="{ 'disabled': item.disabled && item.disabled(), 'trigger-item': item.submenu, 'right': item.submenu && submenuRightSide}"
      (click)="onItemClick(item)"
      (mouseenter)="onMouseOver($event, item.submenu)">
      <mat-icon *ngIf="item.submenu && !submenuRightSide" class="arrow left">arrow_left</mat-icon>
      <mat-icon *ngIf="item.icon" [style.color]="item.iconColor">{{ item.icon }}</mat-icon>
      <div class="menu-item-text">{{ item.label | translate }}</div>
      <mat-icon *ngIf="item.submenu && submenuRightSide" class="arrow right">arrow_right</mat-icon>

      <div class="submenu" *ngIf="item.submenu" [ngClass]="{'left': !submenuRightSide }" [style.left]="submenuRightSide ? '100%' : ('-' + submenuWidth + 'px')" #submenu>
        <div 
          class="menu-item"
          *ngFor="let subItem of item.submenu"
          [ngClass]="{ 'disabled': subItem.disabled && subItem.disabled()}"
          (click)="onItemClick(subItem)">
          <mat-icon *ngIf="subItem.icon" [style.color]="subItem.iconColor">{{ subItem.icon }}</mat-icon>
          <div class="menu-item-text">{{ subItem.label | translate }}</div>
        </div>
      </div>
    </div>
</div>
  